import css from './layout.css'
import { ready, query } from './lib/dom.js'
import { ajaxPost } from './lib/jsfunc.js'

ready(function () {
  setInterval(keep_alive, 60*1000);

  window.onscroll = function() {
    var div = query('.GRID_COLUMNS');
    if (!div){
      return;
    }
    var header = query('.HEADER');
    var offsetH = header.offsetHeight + 10;
    var html = query('html');
    var offsetB = html.offsetHeight - 10;

    var viewportOffset = div.getBoundingClientRect();
    var diff = offsetH - viewportOffset.top;

    var narrow = query(div,'.GRID_NARROW_COLUMN');
    if(diff > 0){
      narrow.classList.remove('fixed-bottom');
      narrow.classList.add('fixed-top');
    }else{
      narrow.classList.remove('fixed-top');
    }

    if(viewportOffset.bottom < offsetB ){
      narrow.classList.remove('fixed-top');
      narrow.classList.add('fixed-bottom');
    }else{
      narrow.classList.remove('fixed-bottom');
    }
  };
})

function keep_alive() {
  var url = document.body.getAttribute('keep-alive-url');
  if(url){
    ajaxPost(url, {}, function (request){});
  }
};
